import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPlanReviewRequirementActiveMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  active: Types.Scalars['Boolean']['input'];
}>;


export type SetPlanReviewRequirementActiveMutation = { __typename?: 'mutation_root', update_plan_review_requirements_by_pk?: { __typename?: 'plan_review_requirements', id: any, active: boolean } | null };


export const SetPlanReviewRequirementActiveDocument = gql`
    mutation setPlanReviewRequirementActive($id: uuid!, $active: Boolean!) {
  update_plan_review_requirements_by_pk(
    pk_columns: {id: $id}
    _set: {active: $active}
  ) {
    id
    active
  }
}
    `;
export type SetPlanReviewRequirementActiveMutationFn = Apollo.MutationFunction<SetPlanReviewRequirementActiveMutation, SetPlanReviewRequirementActiveMutationVariables>;

/**
 * __useSetPlanReviewRequirementActiveMutation__
 *
 * To run a mutation, you first call `useSetPlanReviewRequirementActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlanReviewRequirementActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlanReviewRequirementActiveMutation, { data, loading, error }] = useSetPlanReviewRequirementActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetPlanReviewRequirementActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetPlanReviewRequirementActiveMutation, SetPlanReviewRequirementActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlanReviewRequirementActiveMutation, SetPlanReviewRequirementActiveMutationVariables>(SetPlanReviewRequirementActiveDocument, options);
      }
export type SetPlanReviewRequirementActiveMutationHookResult = ReturnType<typeof useSetPlanReviewRequirementActiveMutation>;
export type SetPlanReviewRequirementActiveMutationResult = Apollo.MutationResult<SetPlanReviewRequirementActiveMutation>;
export type SetPlanReviewRequirementActiveMutationOptions = Apollo.BaseMutationOptions<SetPlanReviewRequirementActiveMutation, SetPlanReviewRequirementActiveMutationVariables>;